import { observer } from 'decorators';
import { makeStyles } from 'hooks';
import { Typography, Grid } from '@material-ui/core';
import NavLink from 'components/navLink';
import Image from 'components/image';
import media from 'services/media';
import { insurerCardUrls } from 'services/forms/insurer';

export default observer(function InsurerCardPhotos({ insurer, clientId, docId, isTentative }) {
  const isSmall = media.is('xs');

  const frontImage = insurerCardUrls(insurer, 'front', { clientId, isTentative, docId });
  const backImage = insurerCardUrls(insurer, 'back', { clientId, isTentative, docId });
  if (!frontImage && !backImage) { return null; }

  return <Grid item>
    <Grid container spacing={isSmall ? 0 : 2}>
      { frontImage &&
        <Grid item xs={12} sm={6}>
          <Typography variant="caption">Front of Card</Typography>
          <InsurerCardPhoto image={frontImage} />
        </Grid>
      }
      { backImage &&
        <Grid item xs={12} sm={6}>
          <Typography variant="caption">Back of Card</Typography>
          <InsurerCardPhoto image={backImage} />
        </Grid>
      }
    </Grid>
  </Grid>;
});

const usePhotoStyles = makeStyles(theme => ({
  imageContainer: {
    width: '100%',
    paddingBottom: '56.25%',
    position: 'relative'
  },
  image: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.primary['100']
  },
  fileImage: {
    maxHeight: '100%',
    maxWidth: '100%'
  }
}));

const InsurerCardPhoto = observer(function InsurerCardPhoto({ image }) {
  const classes = usePhotoStyles();
  if (!image) { return null; }

  return <div className={classes.imageContainer}>
    <NavLink className={classes.image} fileLink={image.url}>
      <Image className={classes.fileImage} file={image.thumbnail} fallbackComponent={<span />} alt="Insurance Card Image" />
    </NavLink>
  </div>;
});